const gerar_arquivo_de_planejamento_matricula = {
  path: "/gerar-arquivo-de-planejamento-de-matricula",
  redirect: "/gerar-arquivo-de-planejamento-de-matricula",
  meta: {
    breadCrumb:
      "Planejamento de Matrícula - Gerar Arquivo de Planejamento Matrícula",
  },
  children: [
    {
      path: "/gerar-arquivo-de-planejamento-de-matricula",
      name: "gerar_arquivo_de_planejamento_de_matricula",
      component: () =>
        import(
          "@/views/GerarArquivoTextoPlanejamentoMatricula/GerarArquivoTextoPlanejamentoMatricula.vue"
        ),
    },
  ],
};

export { gerar_arquivo_de_planejamento_matricula };
